import styled from "@emotion/styled";
import { Link } from "react-router-dom";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 100vh;
  gap: 20px;
  padding: 0 20px 32px 20px;
  box-sizing: border-box;
  text-align: center;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.08) 78.25%,
    rgba(20, 83, 245, 0.5) 122.4%
  );
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  margin-top: -72px;
  gap: 20px;
  flex: 1;
`;

export const Title = styled.h1`
  font-size: 75px;
  color: #111827;

  @media (max-width: 640px) {
    font-size: 40px;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 14px;
  color: #1453f5;
  font-weight: 700;
`;

export const Description = styled.p`
  size: 16px;
  color: #4a5466;
  margin-top: 24px;
  font-weight: 400;
`;

export const Footer = styled.div`
  display: flex;
  font-size: 12px;
  color: #4a5466;
  gap: 24px;
  justify-content: space-between;
  padding: 0 10px;
  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

export const FooterLink = styled(Link)`
  color: #4a5466;
  text-decoration: underline;
`;

export const ButtonGroup = styled.div<{ isReverse?: boolean }>`
  display: flex;
  justify-content: center;
  flex-direction: ${({ isReverse }) => (isReverse ? "row-reverse" : "row")};
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 20px;
  @media (max-width: 640px) {
    flex-direction: ${({ isReverse }) =>
      isReverse ? "column-reverse" : "column"};
  }
`;

export const PorchPassLogo = styled.div`
  position: relative;
  z-index: 1;
  width: 130px;
  height: 32px;
  margin-top: 40px;
`;

export const LogoLink = styled(Link)`
  text-decoration: none;

  & > img {
    max-height: 32px;
    max-width: 130px;
  }
`;

export const TopGradient = styled.div`
  position: absolute;
  z-index: 0;
  width: 1104px;
  height: 1104px;
  top: -1010px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0.4;
  background: linear-gradient(
    180deg,
    rgba(64, 117, 255, 0.08) 0%,
    rgba(20, 83, 245, 0.5) 100%
  );
  filter: blur(150px);
  pointer-events: none;
`;
